import { apiClient } from "@/api";
import type {
  AgentDetailResponse,
  AgentListParams,
  AgentListResponse,
  AgentVersionDetailResponse,
  AgentVersionsParams,
  AgentVersionsResponse,
  CreateAgentPayload,
} from "@/types/agent";
import type { AxiosRequestConfig } from "axios";

export type {
  AdminAgent,
  AdminAgentDetail,
  AgentDetailResponse,
  AgentListParams,
  AgentListResponse,
  AgentVersion,
  AgentVersionDetail,
  AgentVersionDetailResponse,
  AgentVersionsParams,
  AgentVersionsResponse,
  CreateAgentPayload,
} from "@/types/agent";

export const getAgentList = async (
  params: AgentListParams,
  config?: AxiosRequestConfig,
): Promise<AgentListResponse> => {
  const { data } = await apiClient.get<AgentListResponse>("/admin/agents/", {
    ...config,
    params,
  });
  return data;
};

export const deleteAgent = async (agentId: string, config?: AxiosRequestConfig): Promise<void> => {
  await apiClient.delete(`/admin/agents/${agentId}`, config);
};

export const getAgentDetail = async (
  agentId: string,
  config?: AxiosRequestConfig,
): Promise<AgentDetailResponse> => {
  const { data } = await apiClient.get<AgentDetailResponse>(`/admin/agents/${agentId}`, config);
  return data;
};

export const approveAgent = async (
  agent_id: string,
  config?: AxiosRequestConfig,
): Promise<void> => {
  await apiClient.post(`/admin/agents/${agent_id}/approve`, undefined, config);
};

export const rejectAgent = async (agent_id: string, config?: AxiosRequestConfig): Promise<void> => {
  await apiClient.post(`/admin/agents/${agent_id}/reject`, undefined, config);
};

export const createAgent = async (
  payload: CreateAgentPayload,
  config?: AxiosRequestConfig,
): Promise<AgentDetailResponse> => {
  const { data } = await apiClient.post<AgentDetailResponse>("/admin/agents/", payload, config);
  return data;
};

export const updateAgent = async (
  agentId: string,
  payload: CreateAgentPayload,
  config?: AxiosRequestConfig,
): Promise<AgentDetailResponse> => {
  const { data } = await apiClient.put<AgentDetailResponse>(
    `/admin/agents/${agentId}`,
    payload,
    config,
  );
  return data;
};

export const getAgentVersions = async (
  agentId: string,
  params?: AgentVersionsParams,
  config?: AxiosRequestConfig,
): Promise<AgentVersionsResponse> => {
  const { data } = await apiClient.get<AgentVersionsResponse>(`/admin/agents/${agentId}/versions`, {
    ...config,
    params,
  });
  return data;
};

export const getAgentVersionDetail = async (
  agentId: string,
  versionId: string,
  config?: AxiosRequestConfig,
): Promise<AgentVersionDetailResponse> => {
  const { data } = await apiClient.get<AgentVersionDetailResponse>(
    `/admin/agents/${agentId}/versions/${versionId}`,
    config,
  );
  return data;
};
